/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const close = function () {
        navigation.classList.remove('is-open');
        document.documentElement.style.overflowY = null;
    };

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            close();
        }
    });

    /* Close on Escape so the menu can never trap a keyboard user. */
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && navigation.classList.contains('is-open')) {
            close();
        }
    });

    /* Close when a nav link is clicked (single-page anchor or new page). */
    navigation.querySelectorAll('.gh-navigation-menu a, .gh-navigation-actions a').forEach(function (a) {
        a.addEventListener('click', close);
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Source's dropdown() collapses nav items into a "..." button when it
 * thinks they don't fit. With our 3-item nav (Use Cases / Pricing /
 * Company) this triggers at mobile/tablet widths even though we hide
 * the inline menu and render it inside the burger overlay instead.
 * Skip it entirely — the overlay renders the full <ul><li> list. */

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();